<template lang="pug">
.home
  main
    section#above-the-fold.f.f-fc.f-jc
      div#particles-js
      div.above-the-fold__svg
        .We-make-AD-tech-beau We make AD tech beautiful
        .We-love-what-we-are We love what we are doing and we’re always asking ourselves if there’s a better way.
      span#above-the-fold__mouse
        svg(
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="38.433px"
          height="61.777px"
          viewBox="0 0 38.433 61.777"
          enable-background="new 0 0 38.433 61.777"
          xml:space="preserve"
        )
          path(
            fill="#fff"
            d="M35.242,42.562c0,8.84-7.192,16.027-16.028,16.027S3.187,51.402,3.187,42.562V19.066c0-8.836,7.191-16.027,16.027-16.027\
            c8.84,0,16.028,7.191,16.028,16.027V42.562z M20.808,0h-3.187C7.707,0.792,0,9.093,0,19.07v23.492\
            c0,10.594,8.617,19.215,19.214,19.215c10.598,0,19.219-8.621,19.219-19.215V19.066C38.429,9.101,30.722,0.8,20.808,0z"
          )
          path(
            fill="#fff"
            d="M19.214,16.3c-1.425,0-2.582,1.157-2.582,2.586v6.656c0,1.426,1.157,2.586,2.582,2.586c1.426,0,2.582-1.156,2.582-2.586\
            v-6.656C21.796,17.457,20.64,16.3,19.214,16.3z"
          )
    section#company-service.common-section
      #company-service-title.section-title.animated.el_animation {{ $t('公司服务') }}
      .service-girds
        .service-gird.animated.el_animation(v-for="(item, index) in services" :id="'service-gird' + index")
          .service-icon
            img(:src="item.iconUrl")
          .service-title {{ $t(item.title) }}
          .service-memo {{ $t(item.memo) }}
          .view-detail(@click="$router.push(item.link)") {{ $t('了解详情') }}
    section#main-product.common-section
      #main-product-title.section-title.animated.el_animation {{ $t('主要产品') }}
      .product-box.el_animation(
        v-for="(item, index) in displayProducts"
        :id="'product-box' + index"
        :style="{'margin-bottom': (index === displayProducts.length - 1) ? '60px':''}"
        :class="{'animated': index < 3}"
      )
        .product-content
          .product-name {{ item.name }}
          .product-memo {{ item.memo }}
        .product-bg
          .bgc(:style="{'background-color': item.bgc}")
          .view-product-detail(@click="$router.push(item.link)")
            span {{ $t('了解更多产品功能') }}
            img(src="@/assets/icon-entrance.png")
          .product_img
            img(:src="item.imgUrl")
      #btn_viewMore.animated.el_animation(@click="showMoreProducts = !showMoreProducts") {{ showMoreProducts ? $t('收起') : $t('展开更多') }}
    section#partiners.common-section
      #partiners-title.section-title.animated.el_animation {{ $t('他们信赖我们！') }}
      .partiners-box
        #Advertiser.animated.el_animation
          img(src="@/assets/home/partiners_1.png")
        .divider
        #Agent.animated.el_animation
          img(src="@/assets/home/agent.png")
    section
      MobileContact
</template>

<script>
import particlesjson from './particles.json'
import MobileContact from '@/components/MobileContact'
import { animateCSS } from '@/util'

const strartingAnmation = () => {
  var initialScrollTop = parseInt(window.scrollY + 3 * window.innerHeight / 4)
  let elServices = document.getElementById('company-service')
  let elProducts = document.getElementById('main-product')
  let elPartiners = document.getElementById('partiners')
  let elServicesScrollTop = elServices.offsetTop
  let elProductsScrollTop = elProducts.offsetTop
  let elPartinersScrollTop = elPartiners.offsetTop
  let servicesQueue = ['#company-service-title', '#service-gird0', '#service-gird1', '#service-gird2', '#service-gird3', '#service-gird4', '#service-gird5']
  let productQueue = ['#main-product-title', '#product-box0', '#product-box1', '#product-box2', '#btn_viewMore']
  let partinersQueue = ['#partiners-title', '#Advertiser', '#Agent']
  if (elServices.offsetTop <= initialScrollTop) {
    elServices = null
    servicesQueue.forEach((item) => {
      animateCSS(item, 'fadeIn')
    })
  }
  if (elProducts.offsetTop <= initialScrollTop) {
    elProducts = null
    productQueue.forEach((item) => {
      animateCSS(item, 'fadeIn')
    })
  }
  if (elPartiners.offsetTop <= initialScrollTop) {
    elPartiners = null
    partinersQueue.forEach((item) => {
      animateCSS(item, 'fadeIn')
    })
  }

  // var timeout = null
  // var scrollAction = {x: 'undefined', y: 'undefined'}
  // var scrollDirection
  // function scrollFunc () {
  //   if (typeof scrollAction.x === 'undefined') {
  //     scrollAction.x = window.pageXOffset
  //     scrollAction.y = window.pageYOffset
  //   }
  //   var diffX = scrollAction.x - window.pageXOffset
  //   var diffY = scrollAction.y - window.pageYOffset
  //   if (diffX < 0) {
  //     scrollDirection = 'right'
  //   } else if (diffX > 0) {
  //     scrollDirection = 'left'
  //   } else if (diffY < 0) {
  //     scrollDirection = 'down'
  //   } else if (diffY > 0) {
  //     scrollDirection = 'up'
  //   }
  //   scrollAction.x = window.pageXOffset
  //   scrollAction.y = window.pageYOffset
  // }

  window.onscroll = (e) => {
    if (elServices && (Math.abs(window.scrollY - elServicesScrollTop) <= (2 * window.innerHeight / 3) || window.scrollY >= elServicesScrollTop)) {
      elServices = null
      let num = 0
      let interval = setInterval(() => {
        if (servicesQueue[num]) {
          animateCSS(servicesQueue[num], 'fadeInUp')
          num++
        } else {
          num = 0
          clearInterval(interval)
        }
      }, 100)
    }
    if (elProducts && (Math.abs(window.scrollY - elProductsScrollTop) <= (2 * window.innerHeight / 3) || window.scrollY >= elProductsScrollTop)) {
      elProducts = null
      let num = 0
      let interval = setInterval(() => {
        if (productQueue[num]) {
          animateCSS(productQueue[num], 'fadeInUp')
          num++
        } else {
          num = 0
          clearInterval(interval)
        }
      }, 100)
    }
    if (elPartiners && (Math.abs(window.scrollY - elPartinersScrollTop) <= (2 * window.innerHeight / 3) || window.scrollY >= elPartinersScrollTop)) {
      elPartiners = null
      let num = 0
      let interval = setInterval(() => {
        if (partinersQueue[num]) {
          animateCSS(partinersQueue[num], 'fadeIn')
          num++
        } else {
          num = 0
          clearInterval(interval)
        }
      }, 100)
    }

    // clearTimeout(timeout)
    // setTimeout(() => {
    //   scrollFunc()
    //   if (scrollDirection === 'down') {
    //     console.log('down')
    //   } else if (scrollDirection === 'up') {
    //     console.log('up')
    //   }
    // }, 200)
  }
}
export default {
  components: {
    MobileContact
  },
  data () {
    return {
      services: [
        {
          title: '金融服务',
          memo: '专注广告领域的专项金融服务，降本增效，合法合规，分散风险，缓解企业的资金压力。',
          link: '/service/financial-service',
          iconUrl: require('@/assets/service_1.png')
        },
        {
          title: '广告运营',
          memo: '专业成熟的SEM诊断，安心交给我们托管。经验丰富的广告投放团队，无论信息流还是KOL，享受一站式省心服务。',
          link: '/service/ad-marketing',
          iconUrl: require('@/assets/service_2.png')
        },
        {
          title: '资源直采',
          memo: '获取远低于市场行情平均值的优惠政策，帮助企业避开层层中间商，媒介资源采购从此安心与省心。',
          link: '/service/resource-purchasing',
          iconUrl: require('@/assets/service_3.png')
        },
        {
          title: '媒体审计',
          memo: '基于丰富、海量、真实的媒体刊例价、排期执行价、媒体返点、投放效果数据，形成专业的媒体数据池。',
          link: '/service/price-auditing',
          iconUrl: require('@/assets/service_4.png')
        },
        {
          title: '数字化管理',
          memo: '为企业定制标准化营销采购流程，推进数字化管理，实现采购流程透明合规，为企业节省30%的采购成本。',
          link: '/service/digital-management',
          iconUrl: require('@/assets/service_5.png')
        },
        {
          title: '效果评估',
          memo: '帮助企业进行营销资产管理，评估营销渠道表现，通过媒介渠道、媒体、地域、供应商等相关维度做深入分析。',
          link: '/service/effect-evaluation',
          iconUrl: require('@/assets/service_6.png')
        }
      ],
      products: [
        {
          name: 'Rimix',
          memo: 'Rimix通过采购流程数字化、完备的项目数据存储记录及标准的供应商管理体系，帮助企业实现采购流程透明合规可追溯，大幅节约采购成本，平均可为客户节约采购成本30%。',
          link: '/product/rimix',
          bgc: 'rgba(75, 142, 203, .1)',
          reverse: false,
          imgUrl: require('@/assets/libra-2.png')
        },
        {
          name: 'Libra',
          memo: 'Libra是一款专为市场策划人员设计的KOL投前分析工具，累积20,000+KOL服务及效果数据，覆盖60+MCN报价信息，支持指定品牌数据回采。',
          link: '/product/libra',
          bgc: 'rgba(63, 180, 225, .1)',
          reverse: true,
          imgUrl: require('@/assets/home/KTB.png')
        },
        {
          name: 'Bid Agent',
          memo: 'Bid Agent是一款专为中国市场设计的搜索引擎优化管理工具，平均为广告主提升18%的投放效果同时平均提升47%的管理效率。',
          link: '/product/bid_agent',
          bgc: 'rgba(88, 218, 207, .1)',
          reverse: false,
          imgUrl: require('@/assets/home/BidAgent.png')
        }
      ],
      moreProducts: [
        {
          name: '贵了么',
          memo: '连接需求端与供给端，涵盖媒介、营销服务、KOL等7个大类资源，对接超过1,000家供应商的近300个媒体资源，20,000个KOL。',
          link: '/product/guileme',
          bgc: 'rgba(248, 181, 91, .1)',
          reverse: true,
          imgUrl: require('@/assets/home/guileme.png')
        },
        {
          name: 'Data Hub',
          memo: 'Data Hub专注于营销全链路监控及数据管理分析，为客户多渠道多维度衡量营销效果表现。',
          link: '/product/data_hub',
          bgc: 'rgba(88, 218, 207, .1)',
          reverse: false,
          imgUrl: require('@/assets/home/DataHub.png')
        },
        {
          name: 'iMedia Matrix',
          memo: 'iMedia Matrix是一个集海量媒体点位、价格于一体的数据库产品，涉及各行业各品牌的广告投放数据。',
          link: '/product/i_media_matrix',
          bgc: 'rgba(63, 180, 225, .1)',
          reverse: true,
          imgUrl: require('@/assets/home/iMediaMatrix.png')
        },
        {
          name: 'iMedia Tracker',
          memo: 'iMedia Tracker帮助企业整合所有营销资产进行数字化，同时建立营销效果标准，评估营销活动表现。',
          link: '/product/i_media_tracker',
          bgc: 'rgba(75, 142, 203, .1)',
          reverse: false,
          imgUrl: require('@/assets/home/iMediaTracker.png')
        }
      ],
      showMoreProducts: false
    }
  },
  mounted () {
    /* eslint-disable */ particlesJS('particles-js', particlesjson)
    strartingAnmation()
  },
  methods: {

  },
  computed: {
    displayProducts () {
      if (this.showMoreProducts) {
        return this.products.concat(this.moreProducts)
      } else {
        return this.products
      }
    }
  }
}
</script>

<style lang="stylus">
.el_animation
  animation-duration: 1.5s;
.info-button
  z-index: 2
  width: 31px
  height: 31px
  cursor: pointer
  transition: all 0.3s

.info-button:hover
  transform: scale(1.3, 1.3)

.info-content
  position: absolute
  background-color: #555

#above-the-fold
  height: 100vh
  width: 100%
  background-image: url('../../../assets/home/above-the-fold-bg.jpg')
  background-size: cover
  position: relative
  background-position center

#particles-js
  position: absolute
  width: 100%
  height: 50%
  left: 0
  top: 50%
  transform: translateY(-50%)

.above-the-fold__svg
  position: relative
  color #fff
  display flex
  flex-direction column
  justify-content center
  padding-left 24px
  text-align center
  .We-make-AD-tech-beau
    font-size 50px
    font-weight 500
  .We-love-what-we-are
    font-size 16px
    margin-top 6px
    font-weight 300
.above-the-fold__info
  position: absolute
  top: -5%
  left: 54%

.above-the-fold__info.info-1 img
  z-index: 5

.above-the-fold__info.info-1>.above-the-fold__text
  z-index: 4

.above-the-fold__info.info-2
  top: 67%
  left: 76%

.above-the-fold__info.info-3
  top: 18%
  left: 69%

.above-the-fold__button
  cursor: pointer
  width: 40px
  height: 40px
  transition: 0.3s
  position: absolute
  z-index: 3
  &:hover
    transform: scale(1.3, 1.3)

.above-the-fold__button.open
  transform: scale(1.3, 1.3) rotate(45deg)

.above-the-fold__text
  opacity: 0

.above-the-fold__text.open
  position: absolute
  padding: 20px
  width: 250px
  opacity: 0.9
  top: 37px
  left: 23px
  background-color: #535353
  box-shadow: 0 6px 17px 0 rgba(0, 0, 0, 0.5)
  transition: 0.3s
  z-index: 2

.above-the-fold__text.open p
  font-size: 14px
  font-weight: 300
  line-height: 1.86
  color: #fbfbfd

#above-the-fold__mouse
  height: 41px
  position: absolute
  bottom: 30px
  width 100vw
  display flex
  justify-content center

#above-the-fold__mouse
  transform: scale(0.6)

#above-the-fold__mouse path:nth-child(2)
  -moz-animation: scroll-wheel 0.75s ease 0s infinite normal none
  -webkit-animation: scroll-wheel 0.75s ease 0s infinite normal none
  animation: scroll-wheel 0.75s ease 0s infinite normal none

.common-section
  padding 103px 0 0px
  .section-title
    color #303251
    font-size 42px
    text-align center
    font-weight 300
#company-service
  padding-top 72px
  .service-girds
    width 84vw
    margin 62px auto 0
    display grid
    grid-template-columns: auto auto
    grid-template-rows: 33.33% 33.33% 33.33%;
    background-color #fff
    grid-gap 30px 90px
    .service-gird
      .service-icon
        width 72px
        height 72px
        img
          width 100%
          height 100%
      .service-title
        margin 24px 0 12px
        color #303251
        font-size 22px
        font-weight 500
      .service-memo
        color #6E6F85
        font-size 16px
        line-height 1.63 !important
      .view-detail
        color #4b8ecb
        margin-top 34px
        font-size 16px
        font-weight 500
        cursor pointer
#main-product
  margin-top 45px
  .product-box
    margin-top 60px
    .product-content
      width 100vw
      box-sizing border-box
      .product-name
        text-align center
        font-size 43px
        font-weight 500
        color #303251
      .product-memo
        text-align center
        margin 10px 0 6px
        padding 0 72px
        font-size 16px
        line-height 1.69
        color #6E6F85
    .product-bg
      position relative
      padding-top 24px
      box-sizing border-box
      .bgc
        position absolute
        top 0
        left 10vw
        width 80vw
        height 80vw
        border-radius 50%
        z-index -1
      .view-product-detail
        margin 0 auto
        width 222px
        height 60px
        border-radius 5.4px
        box-shadow 0 2px 22px 0 rgba(28, 28, 30, 0.08)
        background-color #fff
        display flex
        align-items center
        justify-content center
        span
          font-size 16px
          font-weight 500
          color #303251
        img
          width 20px
          height 20px
          margin-left 26px
      .product_img
        width 100%
        img
          width 100%
  #btn_viewMore
    width 200px
    height 60px
    border-radius 6px
    background-color rgba(75, 142, 203, .15)
    margin 0 auto
    font-size 20px
    font-weight 500
    color #4b8ecb
    line-height 60px
    text-align center
#partiners
  margin-bottom 60px
  .section-title
    margin-bottom 60px
  .partiners-box
    img
      margin 0 auto
      display block
      width 578px
    .divider
      margin 30px auto
      width 578px
      height 1px
      border-bottom 1px solid rgba(48,50,81,0.15)
</style>
